import { NgModule } from '@angular/core';

import { PickupAsapModule } from './pickupAsap';
import { PickupButtonModule } from './pickupButton';
import { PickupLabelModule } from './pickupLabel';
import { PickupLaterModule } from './pickupLater';
import { PickupNextModule } from './pickupNext';

const toExport: any[] = [
    PickupAsapModule,
    PickupButtonModule,
    PickupLabelModule,
    PickupLaterModule,
    PickupNextModule,
];

@NgModule({
    imports: [
        ...toExport,
    ],
    exports: [
        ...toExport,
    ],
})
export class PickupComponentsModule { }
